define(function (require) {
    var ko = require("knockout");
    var _ = require("underscore");
    var querystring = require("querystring");

    // ctor for FacilityResultViewModel
    return function (parent, data, lat, lng, year, radius) {
        var self = this;

        self.providerId = ko.observable(data.ProviderId);
        self.institutionId = ko.observable(data.Id);
        self.name = ko.observable(data.FacilityName);
        self.phone = ko.observable(data.Phone);
        self.addressId = ko.observable(data.AddressId);
        self.address1 = ko.observable(data.Address1);
        self.address2 = ko.observable(data.Address2);
        self.city = ko.observable(data.City);
        self.state = ko.observable(data.State);
        self.zip = ko.observable(data.Zip);
        self.distance = ko.observable(data.Distance);
        self.providerId = ko.observable(data.ProviderId);
        //self.addressHash = ko.observable(data.AddressHash);
        self.facilityType = ko.observable(data.FacilityType);

        self.telHref = ko.computed(function () {
            return self.phone() ? "tel:" + self.phone().replace(/[^\d]/g, "") : null;
        });

        self.detailUrl = ko.computed(function () {
            var query = {
                providerId: self.providerId(),
                institutionId: self.institutionId(),
                addressId: self.addressId(),
                latitude: lat,
                longitude: lng,
                radius: radius,
                year: year,
                facilityType: self.facilityType()

                // for future use
                // zipOrAddress: self.zipOrAddress(),
                // name: self.name(),
                // villageHealthOnly: self.villageHealthOnly()
            };

            return window.scan.toolDetailUrl + "?" + querystring.stringify(query);
        });

        self.mapUrl = ko.computed(function () {
            var segments = [self.address1(), self.address2(), self.city(), self.state(), self.zip()];

            var search = _.chain(segments).compact().value().join(",");

            return "https://www.google.com/maps/search/" + encodeURIComponent(search);
        });

        self.viewDetails = function () {
            parent.viewDetails(self.providerId(), self.institutionId(), self.addressId(), lat, lng, self.facilityType());
        };
    };
});
